import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useRef, useState } from 'react';
import { useTheme } from '@vertesia/ui/core';
import { MonacoEditor } from '../monacoEditor/MonacoEditor';
/**
 * Reusable JSON editor based on Monaco.
 * Parses and validates JSON, reports errors.
 */
export function JSONEditor({ value, onChange: _onChange, onValidChange, readonly = false, height = '200px', placeholder, className, }) {
    const { theme } = useTheme();
    const editorRef = useRef(undefined);
    const [error, setError] = useState(null);
    const jsonString = useMemo(() => {
        if (value === undefined || value === null)
            return placeholder ?? '{}';
        try {
            return JSON.stringify(value, null, 2);
        }
        catch {
            return '{}';
        }
    }, [value, placeholder]);
    // Validate on change
    const handleChange = useCallback(() => {
        if (!editorRef.current || readonly)
            return;
        const text = editorRef.current.getValue();
        try {
            const parsed = JSON.parse(text);
            setError(null);
            onValidChange?.(parsed);
        }
        catch {
            setError('Invalid JSON');
        }
    }, [readonly, onValidChange]);
    return (_jsxs("div", { className: className, children: [_jsx("div", { className: "border rounded overflow-hidden", style: { height }, children: _jsx(MonacoEditor, { defaultValue: jsonString, editorRef: editorRef, language: "json", theme: theme === 'dark' ? 'vs-dark' : 'vs', onChange: handleChange, options: readonly ? { readOnly: true, domReadOnly: true } : undefined }) }), error && _jsx("p", { className: "text-xs text-destructive mt-1", children: error })] }));
}
/**
 * Get the current parsed value from a JSONEditor ref.
 * Returns the parsed object or null if invalid.
 */
export function getJSONEditorValue(editorRef) {
    if (!editorRef.current)
        return null;
    try {
        return JSON.parse(editorRef.current.getValue());
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=JSONEditor.js.map